import { Route, Switch } from "react-router-dom";
import ReservaListagemPage from "./Listagem";

function ReservasPages() {
  return (
    <Switch>
      <Route
        exact
        path="/administracao/reservas"
        component={ReservaListagemPage}
      />
    </Switch>
  );
}

export default ReservasPages;
